export const getLocalStorage = <T>(
  key: string,
  validator: (x: unknown, key: string) => x is T,
  fallback: T
) => {
  try {
    const x = JSON.parse(localStorage.getItem(key) ?? "null");
    return validator(x, key) ? x : fallback;
  } catch {
    return fallback;
  }
};
